import {
    DefaultFetchError,
    FetchGetId,
    useFetchGetId,
} from '../fetch';

export interface QuizStatus {
    isCustomerQuizDone: boolean;
    isWorkerQuizDone: boolean;
}

export const useQuizStatus = (): FetchGetId<QuizStatus, DefaultFetchError> => (
    useFetchGetId('sub-categories', '', { autoStart: false, startStateLoading: false, authorization: true })
);

export default {
    useQuizStatus
};
